import { ServicesContainer } from '@/services';
import { AddToBagEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, AnalyticsMealType, Commerce, ChipotleTenant, ProductFindingMethod } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ProductListItem } from '../classes/product-list-item';
import { AdobeBaseEvent } from './adobe-base-event';
import { MealType } from '@/models';

export class AdobeCartAddEvent extends AdobeBaseEvent {
  _chipotle? : ChipotleTenant

  event = AnalyticsEventType.AddToBag;
  commerce = { ...this.commerce, productListAdds: { value: 1 } } as Commerce;
  
  constructor(event: AddToBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meal) {
      this.productListItems = ProductListItem.getProductListItems(event.meal, store, services.order.isDelivery(), this.getOrderPath(event.orderPath));
    }

    if(event.isOrderStart) {
      this.commerce.startOrder = { value: 1 };
    }

    if (event.subscribedMealContainsCustomizations == true){
      this._chipotle = { pas: { 
        experienceInteract: { value: 1},
        experienceID: store.state.adobeTarget.mealBuilderMobileCustomizationsExperienceData?.experienceID,
        experienceName: store.state.adobeTarget.mealBuilderMobileCustomizationsExperienceData?.experienceName,
        experienceSource: store.state.adobeTarget.mealBuilderMobileCustomizationsExperienceData?.experienceSource
      } }
    }


    switch (event.mealType) {
      case AnalyticsMealType.Favorite:
        this.commerce.cartAddFavoritedMeal = { value: 1 };
        break;
      case AnalyticsMealType.Recent:
        this.commerce.cartAddRecentMeal = { value: 1 };
        break;
      default:
    }

    switch(event.productFindingMethod) {
      case ProductFindingMethod.Upsell: 
        this.commerce.upsells = { value: 1 };
        this.commerce.upsellAddToBag = { value: 1 };
        this.commerce.pfm = ProductFindingMethod.Upsell;
        break;
      case ProductFindingMethod.AddOn:
        this.commerce.pfm = ProductFindingMethod.AddOn;
        break;
      case ProductFindingMethod.Standalone: 
        this.commerce.pfm = ProductFindingMethod.Standalone;
        break;
    }

    if (event.isPceAddToBag) {
      this.commerce.pceAddToBag = { value: 1 }
    }

    if (event.orderPath){
      this.commerce.orderPath = this.getOrderPath(event.orderPath);
      this.commerce.orderPathCount = { value : 1};
    }
  }

  private getOrderPath(orderPath: string | undefined): string | undefined {
    switch (orderPath) {
      case MealType.BuildYourOwn:
        return 'byoc';
      case MealType.Influencer:
        return 'featured';
      case MealType.Lifestyle:
        return 'pce';
      case MealType.HighProtein:
        return 'high-protein-meals'
      default:
        return orderPath;
    }
  }
} 
